module.exports = __webpack_public_path__ + "20221216:03503e97ddf972ec7716/img/Homescreen-Devices-L.281f516.png";